import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5c0a2f4a")

_pushScopeId("data-v-5c0a2f4a")
const _hoisted_1 = { class: "flex flex-col" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock(_component_DataWrapper, {
    label: "Catatan",
    fontSize: 14
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_LpInput, {
          id: "pusat-resolusi-v2-detail-note",
          modelValue: _ctx.noteModel,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.noteModel = $event)),
          placeholder: "Masukkan catatan Anda",
          type: "textarea",
          textAreaRows: 1,
          resizableTextarea: "",
          onChange: _ctx.resizeTextarea,
          showMaxLength: true,
          maxLength: "255"
        }, null, 8, ["modelValue", "onChange"]),
        _createVNode("button", {
          id: "pusat-resolusi-v2-detail-note-submit",
          disabled: _ctx.isSubmitButtonDisabled || _ctx.loading,
          class: "text-sm text-red-lp-100 underline font-semibold self-end",
          style: {"width":"fit-content"},
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
        }, "Simpan", 8, ["disabled"])
      ])
    ]),
    _: 1
  }))
})